import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { CollapsibleTheme, SectionEl } from "common/components/section";
import { TooltipEl } from "common/components/tooltip";
import { ConfirmEl } from "common/components/confirm";
import { SvgIconEl } from "common/components/svg-icon";
import { SpinnerEl } from "common/components/spinner";
import { TextHighlightEl } from "common/components/text-highlight";
import { TrackedUserIconEl } from "common/widgets/tracked-user-icon";
import { IconSizeType } from "common/constants";
import { Placement } from "common/components/tooltip/types";
import { THEME } from "common/components/confirm/types";
const Aliases = function({ distinctId, aliases, aliasesLoading, aliasesError }) {
  if (aliasesLoading) {
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".user-info-default-alias",
      attrs: { slot: `title`, elref: `profileUserId` }
    }, distinctId), /* @__PURE__ */ jsx(SpinnerEl, null));
  }
  return /* @__PURE__ */ jsx(SectionEl, {
    attrs: {
      "is-closed": true,
      theme: CollapsibleTheme.INLINE
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".user-info-default-alias",
    attrs: { slot: `title`, elref: `profileUserId` }
  }, distinctId), /* @__PURE__ */ jsx("div", {
    sel: ".user-info-aliases-container"
  }, aliases.map((alias) => /* @__PURE__ */ jsx("div", {
    sel: ".user-info-alias"
  }, alias))), aliasesError && /* @__PURE__ */ jsx("div", {
    sel: ".user-info-alias-error"
  }, "Unable to display all distinct ids"));
};
export function template() {
  const { showConfirmDeleteProfile } = this.state;
  const {
    "aliases-loading": aliasesLoading,
    aliases,
    "aliases-error": aliasesError,
    "distinct-id": distinctId,
    "profile-summary": profileSummary,
    "data-group-id": dataGroupId
  } = this.attrs();
  if (!aliases) {
    return /* @__PURE__ */ jsx("div", null);
  }
  const profileType = dataGroupId ? `Group Profile` : `User Profile`;
  const propertiesLoading = this.hasAttribute(`user-properties-loading`);
  const { buttonAttrs: deleteButtonAttrs, tooltip: deleteButtonTooltip } = this.helpers.getDeleteProfileButtonAttrs();
  const detailTypes = [
    {
      icon: `profile`,
      title: `Distinct ID`,
      body: /* @__PURE__ */ jsx(Aliases, {
        distinctId,
        aliases,
        aliasesLoading,
        aliasesError
      })
    },
    {
      icon: `location`,
      title: `Location`,
      body: profileSummary.lastLocation,
      elref: `profileLastLocation`
    },
    {
      icon: `calendar`,
      title: `Updated at`,
      body: profileSummary.lastSeen,
      elref: `profileLastSeen`
    }
  ];
  return /* @__PURE__ */ jsx("div", {
    sel: ".profile-user-summary"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".profile-user-summary-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-panel-section"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".user-profile-header"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".profile-header",
    class: { "sidebar-mode": this.attr(`sidebar-mode`) }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".avatar"
  }, /* @__PURE__ */ jsx(TrackedUserIconEl, {
    attrs: {
      "distinct-id": distinctId,
      "img-src": profileSummary.avatarUrl,
      email: profileSummary.email,
      size: IconSizeType.XL
    }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".name",
    attrs: {
      elref: `profileName`,
      title: profileSummary.name
    }
  }, propertiesLoading ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-skeleton-medium"
  }) : profileSummary.name), /* @__PURE__ */ jsx("div", {
    sel: ".email",
    attrs: {
      elref: `profileEmail`
    }
  }, /* @__PURE__ */ jsx("div", null, profileSummary.email), this.helpers.hasUnsubscribed() && /* @__PURE__ */ jsx(TextHighlightEl, {
    attrs: {
      length: `wide`,
      theme: `failed`,
      text: `Email Unsubscribed`
    }
  }))))), !this.attr(`sidebar-mode`) && /* @__PURE__ */ jsx("div", {
    attrs: { elref: propertiesLoading ? null : `profileDetails` },
    sel: propertiesLoading ? `.mp-skeleton-wrapper` : ``
  }, detailTypes.map(
    ({ icon, title, body, elref }) => propertiesLoading ? /* @__PURE__ */ jsx("div", {
      sel: ".mp-panel-section"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".mp-skeleton-large"
    })) : /* @__PURE__ */ jsx("div", {
      sel: ".mp-panel-section"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".user-info-property",
      class: { "sidebar-mode": this.attr(`sidebar-mode`) }
    }, /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon }
    }), /* @__PURE__ */ jsx("div", {
      sel: ".user-info-detail"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".user-info-detail-type"
    }, title), /* @__PURE__ */ jsx("div", {
      sel: ".user-info-detail-data",
      attrs: {
        elref
      }
    }, body))))
  ), !this.attr(`hide-delete`) ? /* @__PURE__ */ jsx("div", {
    sel: ".mp-panel-section.delete-profile-button"
  }, /* @__PURE__ */ jsx("span", null, /* @__PURE__ */ jsx(ButtonEl, {
    attrs: deleteButtonAttrs,
    on: {
      click: !(deleteButtonAttrs == null ? void 0 : deleteButtonAttrs.disabled) && this.helpers.openDeleteProfileConfirmation
    }
  }, "Delete ", profileType), /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: Placement.Top, offset: 10 }
  }, deleteButtonTooltip)), /* @__PURE__ */ jsx(ConfirmEl, {
    attrs: {
      theme: THEME.DELETE,
      "confirm-button-label": `Delete Profile`,
      open: showConfirmDeleteProfile
    },
    on: {
      submit: this.helpers.handleModalButton
    }
  }, /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-title"
  }, "Delete ", profileType, "?"), /* @__PURE__ */ jsx("div", {
    sel: ".mp-confirm-description"
  }, "This action is permanent and cannot be undone.")))) : null)));
}
